import { Page, Stack, Typography } from "@fideus-ui/core";
import { useEffect } from "react";
import { MaintenancePageLoadedEvent, useTrack } from "../_app/analytics";
import { useTranslation } from "../_app/i18n";
import { translations } from "./translations";

interface MaintenancePageProps {
  message: string;
}

export function MaintenancePage({ message }: MaintenancePageProps) {
  const t = useTranslation(translations);
  const track = useTrack();

  useEffect(() => {
    track(new MaintenancePageLoadedEvent());
  }, [track]);

  return (
    <Page>
      <Stack direction="column" alignItems="center" justifyContent="center">
        <Typography variant="h3" component="h1" gutterBottom>
          {t("title")}
        </Typography>
        <Typography>{message}</Typography>
      </Stack>
    </Page>
  );
}
